import React, { Component, useState } from "react"
import "./Broadcast.css"
import { graphql } from "gatsby"
import "./iframe.css"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { BLOCKS } from "@contentful/rich-text-types"
import LayoutApp from "../layout"
import { CspanView } from "./CSPN-view/cspan"
import SocialAccounts from "../SocialAccounts/SocialAccounts"
import { Search } from "@material-ui/icons"
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faCircle } from '@fortawesome/free-regular-svg-icons'
// import FontAwesome from 'react-fontawesome'
// var FontAwesome = require('react-fontawesome')

// const connector = new AppSearchAPIConnector({
//   searchKey: "search-371auk61r2bwqtdzocdgutmg",
//   engineName: "search-ui-examples",
//   hostIdentifier: "host-2376rb"
// });

const Broadcast = ({data, pageContext,}) => {


    let state = {
      play: false,
      // expandedPodcast: false,
      word: "All",
      searchString: "",
    }
  

  const [searchText, setSearchText] = useState( '' );
  let [expandedPodcast, setexpandedPodcast ] = useState( false);
  let [test , setTest] = useState(false)

  const _executeSearch = async () => {
      console.log(filteredCountries)
    

  }
 let filteredCountries = data.allPodcasts.edges.filter(edge => {
    return edge.node.title.toLowerCase().indexOf(searchText.toLowerCase()) !== -1;
  });

  const check = () => {
    if(searchText === '' && filteredCountries !== searchText) {
      filteredCountries = data.allPodcasts.edges.filter(edge => {
        return edge.node.title.toLowerCase().indexOf(searchText.toLowerCase()) !== -1;
      });
    } else {
      filteredCountries = []
    }
  }
  const expandTest = () => {
    if(test){
    setTest ({
      test : !test
    })
  }
  else{
    setTest ({
      test : !test
    })
  }
    console.log('test')

    console.log(test)
  }
  const expandPodcast = ( val) => {
    setexpandedPodcast ({
      
      expandedPodcast : !val,
      word : "Less",
    })
    console.log(expandedPodcast)
  }
  const contractPodcast = (val) => {
    setexpandedPodcast ({
      
      expandedPodcast : val,
      word : "All",
    })
    console.log(expandedPodcast)
    // expandPodcast();
   
  }

  const getMorePodcast = () => {
    if (test) {
      return (
        <div>
         {
              (filteredCountries.length > 0) && searchText !== '' ?

          filteredCountries.slice(6,11).map( (view,index) => {
                return (
          <div className="w-100">

            <div key={index}  className="row no-gutters mt-5 w-100 d-flex justify-content-center">
              <div className="row no-gutters mt-1 mt-md-2 podcast">
                <div style={{ padding: "1%" }} className="col-8">
                  <p
                    style={{
                      color: "#e13535",
                      fontSize: "14px",
                      fontWeight: "bold",
                    }}
                  >
                    Speaker : {view.node.speaker}
                  </p>
                  <audio
                    controls
                    // className="col-8"
                    style={{ display: "inline-block" }}
                  >
                    <source src={view.node.audio.file.url} type="audio/ogg" />
                    <source src={view.node.audio.file.url} type="audio/mpeg" />
                  </audio>
                </div>

             

                <div
                  className="col-4 card d-flex justify-content-end"
                  style={{
                    // display: "inline-block",
                    margin: "0px",
                    padding: "0px",
                    backgroundColor: "#f1f3f4",
                  }}
                >
                  <img
                    className="card-img"
                    style={{ marginBottom: "0rem" }}
                    src={view.node.image.fluid.src}
                    alt="Card image"
                  />
                </div>
              </div>
              <div className="col-12 d-flex justify-content-center" style={{ marginTop: "20px" }}>
                <small className="card-info">
                  {view.node.title}
                </small>
              </div>
            </div>
          </div>
          )
        })
        : searchText === '' ?
          data.allContentfulPodcast.edges.slice(6,11).map( (view,index) => {
                return (
                  // <div>
          <div key={index} className="w-100">

            <div className="row no-gutters mt-5 w-100 d-flex justify-content-center">
              <div className="row no-gutters mt-1 podcast">
                <div style={{ padding: "1%" }} className="col-8">
                  <p
                    style={{
                      color: "#e13535",
                      fontSize: "14px",
                      fontWeight: "bold",
                    }}
                  >
                    Speaker : {view.node.speaker}
                  </p>
                  <audio
                    controls
                    // className="col-8"
                    style={{ display: "inline-block" }}
                  >
                    <source src={view.node.audio.file.url} type="audio/ogg" />
                    <source src={view.node.audio.file.url} type="audio/mpeg" />
                  </audio>
                </div>


                <div
                  className="col-4 card d-flex justify-content-end"
                  style={{
                    // display: "inline-block",
                    margin: "0px",
                    padding: "0px",
                    backgroundColor: "#f1f3f4",
                  }}
                >
                  <img
                    className="card-img"
                    style={{ marginBottom: "0rem" }}
                    src={view.node.image.fluid.src}
                    alt="Card image"
                  />
                </div>
              </div>
              <div className="col-12 d-flex justify-content-center" style={{ marginTop: "20px" }}>
                <small className="card-info">
                  {view.node.title}
                </small>
              </div>
            </div>
         </div>
        //  </div>
          )
        }) : null
        
        }
{/* <h1>HELLO</h1> */}
        </div>
      )
    } else if (!test) {
      return null
    }
  }

  // render() {
    // console.log('IG')
    // console.log(data.allInstaNode.edges)

    //const id = "#" + this.state.initialItems.id
    const podcast = getMorePodcast()
    console.log(podcast)
    const { currentPage, podcastPages } = pageContext
    const isFirst = currentPage === 1
    const isLast = currentPage === podcastPages
    return (
      <LayoutApp>
            {/* <FontAwesome
        className="super-crazy-colors"
        name="rocket"
        size="2x"
        // spin
        style={{ textShadow: '0 1px 0 rgba(0, 0, 0, 0.1)' }}
      /> */}

           <div className="container-fluid">
          <div className="row mt-sm-1 mb-sm-5 no-gutters">
            <div className="col-12">
              {data.allContentfulBroadcasts.edges.map((edge, i) => {
                return (
                  <div key={i} className="text-justify podcast-text">
                    {documentToReactComponents(edge.node.childContentfulBroadcastsIntroductionRichTextNode.json, {
                      renderNode: {
                        [BLOCKS.PARAGRAPH]: (node, Children) => (
                          <p>{Children}</p>
                        ),

                      },
                    })}
                  </div>

                )})}
            </div>
            <div className="col-6 mt-5">
              <h1 className="broadcast-heading">Podcast</h1>
              <div
                className="col-sm-4  d-flex justify-content-start"
                style={{ paddingLeft: "0px" }}
              >
                <div className="blue-underline"/>
              </div>
              <div className="col-sm-1"/>
              <div className="col-sm-1"/>
            </div>
              {/* <faCircle/> */}
              <div className="col-2"></div>
            <div className="col-4 mt-5 form-group has-search d-flex justify-content-end search-web">
        
            {/* <span
              className="pc-search"
              
              /> */}
            <input
              type="text"
              style={{padding: '0.375rem 0rem 0.375rem 0.75rem'}}
              className="form-control"
              placeholder="Search"
              // onChange={handleClick}
              // onChange={(e) => this.setState({ searchText: e.target.value })}
              // onClick={_executeSearch}
              onChange={e => {setSearchText(e.target.value)
    console.log(searchText);
              check()
              
              }}
            />
            <Search style={{position: 'relative',
    float: 'right',
    bottom: '29px',
    right: '10px',}}/>
            {/* <List items={this.state.items}/> */}
          </div>

          <div
            className="col-6 mt-5 d-flex align-items-end search-mobile"

          >
            <form>
              <input
                type="text"
                name="search"
                id="search-bar"
                // onChange={handleClick}
                
                onChange={e => {
                  setSearchText(e.target.value)
                  console.log(searchText);
                  check()
                            
                            }}
              />
            </form>

          </div>

      
            <div className="row no-gutters w-100">

          <div className="row no-gutters w-100">

          {/* <div className="w-100"> */}
            {
              (filteredCountries.length > 0) && searchText !== '' ?

          filteredCountries.slice(0,6).map( (view,index) => {
                return (
          <div className="w-100">

            <div key={index}  className="row no-gutters mt-5 w-100 d-flex justify-content-center">
              <div className="row no-gutters mt-1 mt-md-2 podcast">
                <div style={{ padding: "1%" }} className="col-8">
                  <p
                    style={{
                      color: "#e13535",
                      fontSize: "14px",
                      fontWeight: "bold",
                    }}
                  >
                    Speaker : {view.node.speaker}
                  </p>
                  <audio
                    controls
                    // className="col-8"
                    style={{ display: "inline-block" }}
                  >
                    <source src={view.node.audio.file.url} type="audio/ogg" />
                    <source src={view.node.audio.file.url} type="audio/mpeg" />
                  </audio>
                </div>

              {/*<List items={data.allContentfulPodcast.edges} />*/}

                <div
                  className="col-4 card d-flex justify-content-end"
                  style={{
                    // display: "inline-block",
                    margin: "0px",
                    padding: "0px",
                    backgroundColor: "#f1f3f4",
                  }}
                >
                  <img
                    className="card-img"
                    style={{ marginBottom: "0rem" }}
                    src={view.node.image.fluid.src}
                    alt="Card image"
                  />
                </div>
              </div>
              <div className="col-12 d-flex justify-content-center" style={{ marginTop: "20px" }}>
                <small className="card-info">
                  {/* Fake News and Russian Information Operations */}
                  {view.node.title}
                </small>
              </div>
            </div>
          </div>
          )
        })
        : searchText === '' ?
          data.allContentfulPodcast.edges.map( (view,index) => {
                return (
                  // <div>
          <div key={index} className="w-100">

            <div className="row no-gutters mt-5 w-100 d-flex justify-content-center">
              <div className="row no-gutters mt-1 podcast">
                <div style={{ padding: "1%" }} className="col-8">
                  <p
                    style={{
                      color: "#e13535",
                      fontSize: "14px",
                      fontWeight: "bold",
                    }}
                  >
                    Speaker : {view.node.speaker}
                  </p>
                  <audio
                    controls
                    // className="col-8"
                    style={{ display: "inline-block" }}
                  >
                    <source src={view.node.audio.file.url} type="audio/ogg" />
                    <source src={view.node.audio.file.url} type="audio/mpeg" />
                  </audio>
                </div>

              {/*<List items={data.allContentfulPodcast.edges} />*/}

                <div
                  className="col-4 card d-flex justify-content-end"
                  style={{
                    // display: "inline-block",
                    margin: "0px",
                    padding: "0px",
                    backgroundColor: "#f1f3f4",
                  }}
                >
                  <img
                    className="card-img"
                    style={{ marginBottom: "0rem" }}
                    src={view.node.image.fluid.src}
                    alt="Card image"
                  />
                </div>
              </div>
              <div className="col-12 d-flex justify-content-center" style={{ marginTop: "20px" }}>
                <small className="card-info">
                  {/* Fake News and Russian Information Operations */}
                  {view.node.title}
                </small>
              </div>
            </div>
         </div>
        //  </div>
          )
        }) : null
        
        }

{podcast}
        {/* <div  style={{cursor : 'pointer'}} onClick={
                    // !expandedPodcast
                    //   ?
                    
                    //  ()=>  expandPodcast(false)
                    //   : ()=> contractPodcast(true)
                    // expandTest
                    !test
                    ?()=> setTest({test:true}) : () =>setTest({test:false})
                  }><p>View All</p></div> */}
      {/* </div> */}



{
  filteredCountries === !searchText || filteredCountries.length === 0 ?
  <div className="col-12 d-flex justify-content-center"><h3> No match Found </h3></div>
 :   searchText === '' ?
            <div className="col-12 d-flex justify-content-center mt-5 ">
              <ul className="pagination">
                {
                  !isFirst && (
                    <li className="page-item">
                      <a
                        className="pagination-a page-link"
                        href={currentPage===2 ? `/` : `/podcast/page/${pageContext.currentPage-1}`}
                        aria-label="Previous"
                      >
                        <span aria-hidden="true">&laquo;</span>
                        <span className="sr-only">Previous</span>
                      </a>
                    </li>)
                }
                {
                  Array.from({ length: podcastPages }).map((page, i) => {
                    return (
                      <li key={i} className="page-item">
                        <a className={ (i+1) === currentPage ? 'pagination-active page-link' : 'pagination-a page-link'} href={ i===0 ? `/` :`/podcast/page/${i+1}`}>
                          {i + 1}
                        </a>
                      </li>
                    )
                  })
                }
                {
                  !isLast && (
                    <li className="page-item">
                      <a className="pagination-a page-link" href={`/podcast/page/${pageContext.currentPage+1}`} aria-label="Next">
                        <span aria-hidden="true">&raquo;</span>
                        <span className="sr-only">Next</span>
                      </a>
                    </li>
                  )
                }
              </ul>
            </div> : null

              }
          </div>

          </div>

     </div>
        </div>
        
        
        
        <CspanView broad={data.allContentfulBroadcasts} videos={data.allContentfulCspanVideos}/>
        <SocialAccounts insta={data.allInstaNode}/>
      </LayoutApp>
    )
  }




export const query = graphql`
  query($skip: Int!, $limit: Int! ) {
    allContentfulBroadcasts {
      edges {
        node {
          cspan1
          cspan2
          cspan3
          slug
          childContentfulBroadcastsIntroductionRichTextNode {
            json
          }
        }
      }
    }
    allContentfulPodcast(limit : $limit, skip : $skip )  {
      edges {
        node {
          audio {
            file {
              url
            }
          }
          title
          speaker
          image {
            fluid(quality: 100) {
              src
            }
          }
        }
      }
    }
    allPodcasts : allContentfulPodcast  {
      edges {
        node {
          audio {
            file {
              url
            }
          }
          title
          speaker
          image {
            fluid(quality: 100) {
              src
            }
          }
        }
      }
    }
    
    allContentfulCspanVideos {
      edges{
        node{
          link
          title
        }
      }
    }
    allInstaNode {
      edges {
        node {
          id
          likes
          comments
          mediaType
          preview
          original
          timestamp
          caption
        }
      }
    }
  }
 
  `
export default Broadcast
